import { AdminRootLayout } from "@/admin/AdminLayout.tsx";
import { createLazyFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu")({
    component: AdminMenu,
});

function AdminMenu() {
    return (
        <AdminRootLayout>
            <Outlet />
        </AdminRootLayout>
    );
}
